<template src="./addassettemplate.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import { required } from "vuelidate/lib/validators";

  export default {
    components: {},
    filters: {},
    data() {
      return {
        FleetSubscription: {},
        CountAssetTemplateChecks: 0,
        ShowLoader: false,
        Editmode: false,
        Submitted: false,
        TemplateExists: false,
        ShowAssetTemplatesPopup:false,
        CountCustomAssetCheck:0,
        CategoryList: [],
        AssetTemplates: [],
        SubCategoryList: [],
        NewTemplate: {
          asset_category_id: "",
          asset_sub_category_id: "",
          name: "",
          AssetChecks: [],
        },
        CopyTemplate: {
          asset_template_id: ""
        }
      };
    },
    validations: {
      NewTemplate: {
        name: { required },
        asset_category_id: { required },
        asset_sub_category_id: { required },
      },
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.GetCompanySubscription();
      this.GetCategoryList();
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
    },
    methods: {
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isAssets = FleetSubscriptionModules.Assets;
        if (isAssets) {
        } else {
          this.$router.push("/settings");
        }
      },
      GetCategoryList() {
        Axios.post(Endpoints.Assets.Category.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response?.data?.success) {
            this.CategoryList = Response.data.CategoryList;
          }
        });
      },
      SetSubCategories() {
        this.SubCategoryList = [];
        var CategoryID = this.NewTemplate.asset_category_id;
        if (CategoryID > 0) {
          this.CategoryList.forEach((element) => {
            if (
              element.id === CategoryID &&
              element.sub_categories &&
              element.sub_categories.length > 0
            ) {
              this.SubCategoryList = element.sub_categories;
            }
          });
        }
      },
      GetAssetTemplateChecks() {
        if(this.CopyTemplate.asset_template_id > 0){
            this.ShowLoader = true;
            Axios.post(Endpoints.Assets.TemplateChecks.List, {
              token: localStorage.getItem("token"),
              fleet_asset_template_id: this.CopyTemplate.asset_template_id,
            }).then((Response) => {
              this.ShowLoader = false;
              this.CopyTemplate.asset_template_id = "";
              this.ShowAssetTemplatesPopup = false;
              this.NewTemplate.AssetChecks = Response.data.AssetChecks;
              this.NewTemplate.AssetChecks.forEach((element, index) => {
              if (this.NewTemplate.AssetChecks[index]["description"]) {
                this.NewTemplate.AssetChecks[index]["description"] = this.NewTemplate.AssetChecks[
                  index
                ]["description"].replaceAll(/(?:\\[rn])+/g, "");
              }

              if (element.required == 1) {
                this.NewTemplate.AssetChecks[index]["required"] = true;
              } else {
                this.NewTemplate.AssetChecks[index]["required"] = false;
              }
              this.CountAssetChecks();
            });
            });
            
          }else{
            this.ShowAssetTemplatesPopup = false;
          }
      },
      CountAssetChecks() {
        this.CountAssetTemplateChecks = this.NewTemplate.AssetChecks.length;
      },
      AssetTemplatesPopup(){
        this.ShowAssetTemplatesPopup = true;
        this.GetTemplatesList();
      },
      GetTemplatesList() {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.Assets.Template.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.ShowLoader = false;
            this.AssetTemplates = Response.data.Templates;
          }
        });
      },   
      SaveAssetTemplate(SaveType = "Add") {
        this.Submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.TemplateExists = false;
        var error = false;
        this.NewTemplate.AssetChecks.forEach((element) => {
          if (element.id == 0) {
            if (element.name == "") {
              error = true;
              this.$swal("Please Enter Check Name", "", "error");
              this.Submitted = false;
              return true;
            }
          }
        });
        if (!error) {
          this.Submitted = true;
          this.NewTemplate['SaveType'] = SaveType;
          Axios.post(Endpoints.Assets.Template.Create, {
            token: localStorage.getItem("token"),
            ...this.NewTemplate,
          }).then((Response) => {
            if(Response?.data?.success == true){
            this.Submitted = false;
            this.$swal(
              "Asset Template Saved Successfully",
              "",
              "success"
            ).then(() => {
              this.$router.push("/asset/templates");
            });
          }else{
            this.Submitted = false;
            if(Response.data.template_exists){
              this.$swal({
              title: "Alert!",
              
              html: `
              Asset Template already exits for this sub category.<br /><br />
              <button class="swal2-confirm swal2-styled swal2-default-outline" id="replace-button">Replace</button>
              <button class="swal2-confirm swal2-styled swal2-default-outline" id="merge-button">Merge</button>
            `,
              icon: "warning",
              showCancelButton: true,
              showConfirmButton: false,
              confirmButtonColor: "#514b71",
              cancelButtonColor: "#aaa",
              cancelButtonText: "Ok",
              reverseButtons: false,
            });
            document.getElementById('replace-button').addEventListener('click', () => {
              this.SaveAssetTemplate("Replace");
                this.$swal.close();
              });

              document.getElementById('merge-button').addEventListener('click', () => {
                this.SaveAssetTemplate("Merge");
                this.$swal.close();
              });
            }else{
              this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          }
          });
        }
      },
      DeleteTemplateCheck(tempid) {
        this.$swal({
          title: "Are you sure You want to delete this Check Record?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.NewTemplate.AssetChecks.forEach((value, index) => {
                if (value.id == tempid) {
                  this.NewTemplate.AssetChecks.splice(index, 1);
                }
              });
              this.$swal(
                "Asset Template Record Deleted Successfully",
                "",
                "success"
              ).then(() => {
              });
          }
        });
      },
      AddCustomAssetCheck() {

        if (
          this.FleetSubscription &&
          this.FleetSubscription.allowed_total_asset_checks >
            this.CountAssetTemplateChecks
        ) {

          this.Editmode = true;
          var obj = {
            custom: 1,
            id: 0,
            name: "",
            description: "",
            fleet_asset_template_id: 0,
            position: this.NewTemplate.AssetChecks.length + 1,
            required: 0,
            status: 1,
          };
          this.NewTemplate.AssetChecks.push(obj);
          this.CountAssetChecks();
        }else {
          this.$swal(
            "You have reached your subscription's maximum allowed asset checks. Please contact us to add more checks",
            "",
            "error"
          );
        }
      },
    },
  };
</script>

<style type="text/css"></style>
